<template>
  <div class="grid grid-cols-12 col-span-12">
    <div class="col-span-3 p-8 pt-16 lg:p-12 bg-transaction-gradient
                space-y-12">
      <ValueInput :label="$t('sum')"
                  v-model.trim="$v.form.sum.$model"
                  :currency_id="!!form.account ? form.account.currency.id : null"
                  :class="{'--error':$v.form.sum.$error}"
                  @focusin="open_form = true">
        <template v-slot:errors>
          <div class="error" v-if="$v.form.sum.$invalid">{{ $t('fieldRequired') }}</div>
        </template>
      </ValueInput>
      <ValueInput v-if="!!form.account
                        && !!form.account.commission
                        && (transactionType === 2)
                        && open_form"
                  :label="$t('commission')"
                  v-model="$v.form.fee.$model"
                  :currency_id="!!form.account ? form.account.currency.id : null">
      </ValueInput>
      <ValueInput v-if="transactionType === 3"
                  :label="$t('sum_to')"
                  v-model="$v.form.sum_to.$model"
                  :class="{'--error':$v.form.sum_to.$error}"
                  :currency_id="!!form.account_to ? form.account_to.currency.id : null">
        <template v-slot:errors="">
          <div class="error" v-if="$v.form.sum_to.$invalid">{{ $t('fieldRequired') }}</div>
        </template>
      </ValueInput>
    </div>
    <div class="col-span-9 p-8 pt-16 lg:p-12
                grid grid-cols-2 col-gap-12 row-gap-12">
      <AccountsSelect v-model="$v.form.account.$model"
                      :class="{'--error':$v.form.account.$error}"
                      :label="transactionType === 1 ? $t('accountTo') : $t('accountFrom')"
                      hidden-mode="exclude"
                      :accounts="accounts.data"
                      :account_groups="accounts_by_groups"
                      :grouped="accounts_by_groups.length > 1"
                      @open="open_form = true">
        <template v-slot:errors>
          <div class="error" v-if="$v.form.account.$invalid">{{ $t('fieldRequired') }}</div>
        </template>
      </AccountsSelect>
      <!-- commission field for transfer -->
      <ValueInput v-if="!!form.account
                        && !!form.account.commission
                        && (transactionType === 3)"
                  :label="$t('commission')"
                  class="transfer-commission"
                  textAlign="left"
                  v-model="$v.form.fee.$model"
                  :currency_id="!!form.account ? form.account.currency.id : null">
      </ValueInput>
      <div v-else-if="transactionType === 3"></div>
      <!-- account destination field for transfer -->
      <AccountsSelect v-if="transactionType === 3"
                      v-model="form.account_to"
                      :class="{'--error':$v.form.account_to.$error}"
                      :label="$t('accountTo')"
                      hidden-mode="exclude"
                      :accounts="accountTransfer"
                      :account_groups="accountTransferGroups"
                      :grouped="accounts_by_groups.length > 1"
                      @open="open_form = true">
        <template v-slot:errors>
          <div class="error" v-if="$v.form.account_to.$invalid">{{ $t('fieldRequired') }}</div>
        </template>
      </AccountsSelect>
      <!-- category selects -->
      <BaseSelect v-model="form.incomeCategory"
                  v-if="transactionType === 1"
                  :class="{'--error':$v.form.incomeCategory.$error}"
                  class="col-span-1"
                  track-by="id"
                  :allow-empty="false"
                  :options="incomes"
                  :selectLabel="$t('categoryIncome')"
                  label="title"
                  :tag-placeholder="$t('createNewIncomeLabel')"
                  :taggable="true"
                  @tag="addIncomeSource">
        <template v-slot:errors>
          <div class="error" v-if="$v.form.incomeCategory.$invalid">{{ $t('fieldRequired') }}</div>
        </template>
      </BaseSelect>
      <BaseSelect v-model="form.expenseCategory"
                  v-else-if="transactionType === 2 || (transactionType === 3 && transactionOptions['category'])"
                  :class="{'--error':$v.form.expenseCategory.$error}"
                  class="col-span-1"
                  :selectLabel="$t('categoryExpense')"
                  :options="expenses_by_groups"
                  :allow-empty="false"
                  :group-select="false"
                  :searchable="true"
                  :show-labels="false"
                  label="title"
                  group-label="title"
                  group-values="childs"
                  :tag-placeholder="$t('createNewExpenseLabel')"
                  :taggable="true"
                  @tag="addExpenseCategory">
        <template v-slot:errors>
          <div class="error" v-if="$v.form.expenseCategory.$invalid">{{ $t('fieldRequired') }}</div>
        </template>
      </BaseSelect>
      <div v-show="open_form" class="col-span-2 grid grid-cols-2 col-gap-12 row-gap-12">
        <BaseSelect v-if="transactionOptions['agent'] && transactionType !== 3 && spaceUseContractors"
                    class="col-span-1"
                    v-model="form.contractor"
                    :options="computedContractors"
                    :allow-empty="true"
                    :selectLabel="$t('contractor')"
                    label="title"
                    track-by="id"
                    placeholder="Выберите ..."
                    :show-labels="false">
          <template v-slot:noOptions="">
            <div class="w-full whitespace-normal">
              {{ $t('noContractors') }}
              <router-link :to="{name:'settings-contractors'}" class="text-red">
                {{ $t('noContractorsHere') }}
              </router-link>
            </div>
          </template>
        </BaseSelect>
        <BaseTextarea v-if="transactionOptions['comment']"
                      class="col-span-2"
                      v-model="form.comment"
                      :label="$t('comment')"/>
        <BaseSelect v-if="transactionOptions['tags']"
                    class="col-span-1"
                    v-model="form.tags"
                    :options="tags_list"
                    :selectLabel="$t('tags')"
                    label="title"
                    track-by="id"
                    :tag-placeholder="$t('tagCreateNew')"
                    :close-on-select="false"
                    :multiple="true"
                    :taggable="true"
                    @tag="addTag"
                    :show-labels="false">
          <template v-slot:noOptions="">
            <div class="w-full whitespace-normal">
              {{ $t('noTags') }}
            </div>
          </template>
        </BaseSelect>
        <BaseSelect v-model="form.repeat_type"
                    v-if="displayRepeatOption"
                    class="col-start-1 col-span-1"
                    :selectLabel="$t('repeatLabel')"
                    label="name"
                    :options="repeatOptions"
                    :allow-empty="false"
                    :searchable="true"
                    :show-labels="false"/>
        <div class="col-span-2 flex items-center justify-start">
          <BaseButton @click="createTransaction"
                      :loading="submitted"
                      :theme="buttonTheme">
            {{ buttonText }}
          </BaseButton>
          <VueCtkDateTimePicker v-if="open_form"
                                id="transaction-date"
                                class="inline"
                                v-model="form.date"
                                format="YYYY-MM-DD"
                                :formatted="dateFormatted"
                                :locale="$i18n.locale"
                                :auto-close="true"
                                :only-date="true"
                                :no-label="true"
                                :no-clear-button="true"
                                :no-button="true"
                                color="#2D4C5E"/>
          <VueCtkDateTimePicker v-if="open_form && current_space.data.time_enabled && !displayRepeatOption"
                                id="transaction-time"
                                class="inline"
                                v-model="form.time"
                                format="HH:mm"
                                formatted="HH:mm"
                                :locale="$i18n.locale"
                                :only-time="true"
                                :no-clear-button="true"
                                :no-label="true"
                                :no-button="true"
                                color="#2D4C5E"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import {decimal, required, requiredIf} from "vuelidate/lib/validators";
import ValueInput from "@/components/UI/BaseInput/ValueInput";
import BaseTextarea from "@/components/UI/BaseTextarea";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import AccountsSelect from "@/components/UI/BaseSelect/AccountsSelect";
import BaseButton from "@/components/UI/BaseButton";

export default {
  name: "CreateTransactionForm",
  components: {BaseButton, BaseTextarea, BaseSelect, AccountsSelect, ValueInput},
  props: {
    transactionType: {
      type: Number,
      required: true
    },
    transactionOptions: {
      type: Object,
      required: true
    },
    defaultFormIsClosed: {
      type: Boolean,
    },
    initialDate: {
      type: String
    }
  },
  data() {
    return {
      open_form: true,
      submitted: false,
      form: {
        sum: null,
        sum_to: null,
        fee: null,
        account: null,
        account_to: null,
        expenseCategory: null,
        incomeCategory: null,
        contractor: null,
        comment: '',
        tags: [],
        repeat_type: null,
        date: null,
        time: null,
      }
    }
  },
  validations: {
    form: {
      sum: {
        required,
        decimal,
      },
      sum_to: {
        required: requiredIf(function () {
          return this.transactionType === 3
        }),
        decimal,
      },
      fee: {
        decimal,
      },
      account: {
        required
      },
      expenseCategory: {
        required: requiredIf(function () {
          return this.transactionType === 2
        }),
      },
      incomeCategory: {
        required: requiredIf(function () {
          return this.transactionType === 1
        }),
      },
      account_to: {
        required: requiredIf(function () {
          return this.transactionType === 3
        }),
      }
    }
  },
  computed: {
    ...mapState('space', ['current_space']),
    ...mapState('space/expenses', ['expenses']),
    ...mapState('space/incomes', ['incomes']),
    ...mapState('space/tags', ['tags_list']),
    ...mapState('space/accounts', ['accounts']),
    ...mapGetters('space', ['spaceUseContractors']),
    ...mapGetters('space/accounts', ['accounts_by_groups', 'accounts_not_hidden']),
    ...mapGetters('space/expenses', ['expenses_by_groups']),
    ...mapGetters('space/contractors', ['contractorsByPopularity']),
    ...mapGetters('cabinet/constants', ['getConstantList']),
    buttonTheme() {
      const buttonThemes = {
        2: 'red',
        1: 'green',
        3: 'yellow'
      }
      return buttonThemes[this.transactionType];
    },
    buttonText() {
      let buttonTextByType = {
        2: this.$t('addExpense'),
        1: this.$t('addIncome'),
        3: this.$t('addTransfer')
      }

      return !this.transactionIsInPast && this.transactionOptions['calendar'] && this.transactionType !== 3
          ? this.$t('planLabel')
          : buttonTextByType[this.transactionType];
    },
    computedContractors() {
      return this.contractorsByPopularity(this.transactionType);
    },
    accountTransfer() {
      if (!this.form.account) {
        return this.accounts_not_hidden;
      } else {
        return this.accounts_not_hidden.filter(i => i.id !== this.form.account.id);
      }
    },
    accountTransferGroups() {
      if (!this.form.account) {
        return this.accounts_by_groups
      } else {
        return this.accounts_by_groups.map(group => {
          return {
            ...group,
            childs: group.childs.filter(acc => acc.id !== this.form.account.id)
          }
        })
      }
    },
    dateFormatted() {
      const isToday = this.$moment(this.form.date, 'YYYY-MM-DD').startOf('day').unix() === this.$moment().startOf('day').unix()

      return isToday ? this.$t('today') : 'DD.MM.YYYY'
    },
    transactionIsInPast() {
      return this.$moment(this.form.date, 'YYYY-MM-DD').diff(this.$moment().startOf('day'), 'days') < 0;
    },
    displayRepeatOption() {
      return !this.transactionIsInPast && this.transactionOptions['calendar'] && this.transactionType !== 3
    },
    repeatOptions() {
      return this.getConstantList('calendar_repeat')
    }
  },
  methods: {
    ...mapActions('space/tags', ['createTag']),
    ...mapActions('space/expenses', ['getExpenses', 'createExpense']),
    ...mapActions('space/incomes', ['getIncomes', 'createIncomeSource']),
    ...mapActions('cabinet/currencies', ['exchangeValues']),
    addTag(val) {
      const tag = {title: val, space_id: this.current_space.data.id};
      this.createTag(tag).then(res => {
        if (res.body.success) {
          this.form.tags.push(res.body.data);
          this.$store.commit('space/tags/pushTag', res.body.data);
        }
      })
    },
    addExpenseCategory(val) {
      const expenseCategory = {
        space_id: this.current_space.data.id,
        title: val,
      };
      this.createExpense(expenseCategory).then(res => {
        if (res.body.success) {
          this.form.expenseCategory = res.body.data
          this.getExpenses();
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    addIncomeSource(val) {
      let incomeSource = {
        space_id: this.current_space.data.id,
        title: val,
      };
      this.createIncomeSource(incomeSource).then(res => {
        if (res.body.success) {
          this.form.incomeCategory = res.body.data
          this.getIncomes();
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    handleFee() {
      const {account, sum} = this.form;

      if (!!account && account.commission && !!sum) {
        if (account.commission_type === 1) {
          const s = sum * 100,
              f = +account.commission_value;
          this.form.fee = (s * f / 10000).toFixed(account.currency.decimals);
        } else {
          this.form.fee = +account.commission_value;
        }
      } else {
        this.form.fee = null;
      }
    },
    setInitialDate() {
      if (this.initialDate) {
        this.form.date = this.initialDate;
      } else {
        this.form.date = this.$moment().format('YYYY-MM-DD');
      }
      this.form.time = this.$moment().format('HH:mm');
    },
    handleTransferCurrency() {
      if (!this.form.account || !this.form.account_to) return
      if (!this.form.account_to.currency.id) return
      if (!this.form.sum) {
        this.form.sum_to = null;
        return
      }

      let val = this.form.sum,
          curr_from = this.form.account.currency.id,
          curr_to = this.form.account_to.currency.id;
      if (curr_from === curr_to) {
        this.form.sum_to = val
      } else {
        let data = {
          currency_from: curr_from,
          currency_to: curr_to,
          sum: val,
          date_time: this.current_space.data.time_enabled ?
              `${this.form.date} ${this.form.time}:00`
              :
              `${this.form.date} ${this.$moment().format('HH:mm')}:00`,
          timezone: this.$moment.tz.guess()
        }
        this.exchangeValues(data).then((res) => {
          if (res.body.success) {
            this.form.sum_to = res.body.data;
          }
        });
      }
    },
    clearForm() {
      this.form.sum = null;
      this.form.fee = null;
      this.form.sum_to = null;
      this.form.account = null;
      this.form.account_to = null;
      this.form.expenseCategory = null;
      this.form.incomeCategory = null;
      this.form.contractor = null;
      this.form.comment = '';
      this.form.tags = [];
      this.submitted = false;
      this.form.repeat_type = this.repeatOptions[0]
      this.$cookies.remove('trans_date');
      this.setInitialDate()
      this.$v.$reset();
    },
    openForm() {
      this.open_form = true;
    },
    resetAfterSuccess() {
      this.form.sum = null;
      this.form.sum_to = null;
      this.form.fee = null;
      this.form.comment = null;
      this.form.contractor = null;
      this.form.expenseCategory = null;
      this.form.incomeCategory = null;
      this.form.comment = '';
      this.form.tags = [];
      this.form.repeat_type = this.repeatOptions[0]
      this.submitted = false;
      this.$v.$reset();
    },
    resetAfterError() {
      this.submitted = false;
      this.$v.$reset();
    },
    createTransaction() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.submitted = true;
        this.$emit('createTransaction', this.form);
      }
    }
  },
  watch: {
    'form.sum': {
      handler() {
        this.handleFee();
        if (this.transactionType === 3) {
          this.handleTransferCurrency();
        }
      }
    },
    'form.account': {
      handler(val, oldVal) {
        if (!!val) {
          this.$cookies.set('trans_acc_id', val.id)
        } else {
          this.$cookies.remove('trans_acc_id')
        }

        this.handleFee()
        if (this.transactionType === 3) {
          this.handleTransferCurrency();
        }
        if (this.transactionType === 3 && !!this.form.account_to) {
          //reset destination account if selected the same
          if (this.form.account.id === this.form.account_to.id) {
            this.form.account_to = oldVal;
          }
        }
      }
    },
    'form.account_to': {
      handler: 'handleTransferCurrency'
    },
    'form.date': {
      handler(newVal) {
        this.$emit('onDateChanged', newVal)
      }
    },
    transactionType(newVal) {
      if (newVal === 3 && !!this.form.account && !this.form.account_to) {
        const others = this.accounts_not_hidden.filter(acc => acc.id !== this.form.account.id)
        this.form.account_to = others[0] || null
      }
    },
    expenses: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal.data.length === 1) {
          this.form.expenseCategory = this.expenses.data[0]
        }
      }
    },
    incomes: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal.length === 1) {
          this.form.incomeCategory = this.incomes[0]
        }
      }
    },
  },
  mounted() {
    this.setInitialDate();
    if (this.defaultFormIsClosed) {
      this.open_form = false
    }
    if (!!+this.$cookies.get('trans_acc_id')) {
      this.form.account = this.accounts_not_hidden.find(i => i.id === +this.$cookies.get('trans_acc_id')) || null
    }
    this.form.repeat_type = this.repeatOptions[0]
  },
  i18n: {
    messages: {
      en: {
        fieldRequired: 'Field is required',
        sum: 'Sum',
        sum_to: 'Received amount',
        commission: 'Commission',
        accountFrom: 'From account',
        accountTo: 'To account',
        categoryExpense: 'Expense category',
        categoryIncome: 'Income category',
        contractor: 'Contractor',
        noContractors: 'You have no contractors, you can add them',
        noContractorsHere: 'here',
        comment: 'Comment',
        tags: 'Tags',
        tagCreateNew: 'Create new',
        createNewIncomeLabel: 'Create new',
        createNewExpenseLabel: 'Create new',
        noTags: 'You have no tags, enter name to create the new tag',
        repeatLabel: 'Repeat',
        planLabel: 'Schedule',
        addExpense: 'Add expense',
        addIncome: 'Add income',
        addTransfer: 'Add transfer',
        today: '[Today]' //brackets are need for momentjs formatting
      },
      ru: {
        fieldRequired: 'Поле обязательно',
        sum: 'Сумма',
        sum_to: 'Поступит',
        commission: 'Комиссия',
        accountFrom: 'Со счета',
        accountTo: 'На счет',
        categoryExpense: 'Категория расхода',
        categoryIncome: 'Источник дохода',
        contractor: 'Контрагент',
        noContractors: 'У вас пока нет контрагентов, вы можете добавить их',
        noContractorsHere: 'здесь',
        comment: 'Комментарий',
        tags: 'Теги',
        tagCreateNew: 'Добавить новый',
        createNewIncomeLabel: 'Добавить новый',
        createNewExpenseLabel: 'Добавить новую',
        noTags: 'У вас нет тегов, введите название первого тега',
        repeatLabel: 'Повторять',
        planLabel: 'Запланировать',
        addExpense: 'Внести расход',
        addIncome: 'Внести доход',
        addTransfer: 'Внести перевод',
        today: 'Сегодня'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.button {
  @apply mr-12;
  width: 255px;
}

.transfer-commission {
  width: 130px;
}
</style>